import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import "../css/scheduleTimetable.css";
import "../../subjectTeachersAvailability/subjectTeacherAvailability.css";

import Loader from "common/components/Loader";
import Header from "common/js/header/header";

import { generateAutoScheduleSvc, generateScheduleSvc, generateScheduleBSvc, generateScheduleCSvc, excelReportSvc } from "./scheduleTimetableSvc";
import ScheduleHeader2 from "./scheduleHeader2";
import ScheduleTeacher2 from "./scheduleTeacher2";
import SubjectTeachersAvailability from "sms/tt/subjectTeachersAvailability/subjectTeachersAvailablity";

const ScheduleTimetableCtrl2 = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [schKey, setSchKey] = useState(0);
    const [sessionId, setSessionId] = useState(0);
    const [flgAvailabilityReportVisible, setFlgAvailabilityReportVisible] = useState(false);
    const [showCommonClassModal, setShowCommonClassModal] = useState(false);

    const scheduleTimetableA = () => {
        setLoader("block");
        setOpacity(0.5);
        generateScheduleSvc(sessionId, scheduleTimetableResponse);
    };

    const scheduleTimetableB = () => {
        setShowCommonClassModal(true);
    };

    const scheduleTimetableC = () => {
        setLoader("block");
        setOpacity(0.5);
        generateAutoScheduleSvc(sessionId, scheduleTimetableResponse);
    };

    const handleCommonClassChoice = (commonClsOnly) => {
        setShowCommonClassModal(false);
        setLoader("block");
        setOpacity(0.5);
        generateScheduleBSvc(commonClsOnly, sessionId, scheduleTimetableResponse);
    };

    const scheduleTimetableResponse = (data) => {
        if (data.status === "Success") {
            toast.success(data.message);
            setSchKey(prevKey => prevKey + 1);
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    };

    const openAvailibilityReport = () => {
        setOpacity(0.5);
        setFlgAvailabilityReportVisible(true);
    }
    
    const closeAvailibilityReport = () => {
        setOpacity(1);
        setFlgAvailabilityReportVisible(false);
    }
    
    function getData() {
        setLoader("block");
        setOpacity(0.5);
        excelReportSvc(cbViewReportResponse);
    }
    function cbViewReportResponse(data) {
        // console.log("cbViewReportResponse called", data);
        setLoader("none");
        setOpacity(1);
        var url = document.createElement("a");
        url.href = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
        );
        url.download = "Excel Report Report.xlsx";
        document.body.appendChild(url);
        url.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(url);
        }, 200);
    }

    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: opacity === 1 ? "pointer" : "none",
                    pointerEvents: opacity === 1 ? "auto" : "none",
                    opacity: opacity,
                }}
            >
                <div
                    className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-centered "
                    style={{ marginTop: "15px" }}
                >
                    <ScheduleHeader2
                        sessionId={sessionId}
                        setSessionId={setSessionId}
                        schKey={'sh_' + schKey}
                        setSchKey={setSchKey}
                        scheduleTimetableA={scheduleTimetableA}
                        getData={getData}
                        scheduleTimetableB={scheduleTimetableB}
                        scheduleTimetableC={scheduleTimetableC}
                        openAvailibilityReport={openAvailibilityReport}
                    />
                </div>
                <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-centered padding-remove">
                    <ScheduleTeacher2
                        key={'st_' + schKey}
                        sessionId={sessionId}
                        setLoader={setLoader}
                        setOpacity={setOpacity}
                    />
                </div>
            </div>
            {flgAvailabilityReportVisible ?
                <div className="subTchAvailabilityPopup">
                    <SubjectTeachersAvailability
                        selSessionId={sessionId}
                        closePopup={closeAvailibilityReport}
                    />
                </div>
                : null}

            {/* Custom Yes/No Modal */}
            {showCommonClassModal && (
                <div className="modal-backdrop" style={{
                    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                    background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
                }}>
                    <div style={{
                        background: "#fff", padding: 24, borderRadius: 8, minWidth: 320, boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                    }}>
                        <h4>Generate Schedule</h4>
                        <p>Do you want to generate the schedule for <b>Common Classes only</b>?</p>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 16 }}>
                            <button className="btn btn-primary" onClick={() => handleCommonClassChoice(false)}>Full schedule</button>
                            <span
                                onClick={() => handleCommonClassChoice(true)}
                                title="Schedule only common classes"
                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                            >
                                Only groups
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScheduleTimetableCtrl2;
